import { styled } from '@mui/material';
export const TextFieldWrapper = styled('div')(({ theme }) => ({
  display: 'block',
  width: '100%',
  fontFamily: 'Satoshi Variable !important',

}));
